import { Maskable } from "models/domain/interfaces/maskable";
import formatWithMask from "utils/masks/format-with-masks";
import masks from "utils/masks/masks";
import { removeMasks } from "utils/remove-masks";


export class Cpf implements Maskable {
    private value: string;

    constructor(value: string) {
        this.value = value;
    }

    static fromString(value: string) {
        value = removeMasks(value.trim());
        if (value.length !== 11) {
            throw new Error('CPF com números inválidos.')
        }

        const cpf = new Cpf(value);

        if (!this.checkIsValid(value)) {
            throw new Error('CPF em formato inválido.');
        }        

        return cpf;
    }

    private static checkIsValid(value: string): boolean {
        let sum;
        let modOfDivision;
        sum = 0;
        if (value === "00000000000") return false;

        for (let i = 1; i <= 9; i++) sum = sum + parseInt(value.substring(i - 1, i)) * (11 - i);
        modOfDivision = (sum * 10) % 11;

        if ((modOfDivision === 10) || (modOfDivision === 11)) modOfDivision = 0;
        if (modOfDivision !== parseInt(value.substring(9, 10))) return false;

        sum = 0;
        for (let i = 1; i <= 10; i++) sum = sum + parseInt(value.substring(i - 1, i)) * (12 - i);
        modOfDivision = (sum * 10) % 11;

        if ((modOfDivision === 10) || (modOfDivision === 11)) modOfDivision = 0;
        if (modOfDivision !== parseInt(value.substring(10, 11))) return false;
        return true;
    }

    public getWithMask() {
        const { masked } = formatWithMask({
            mask: masks.BRL_CPF,
            text: this.value
        });
        return masked;
    }

    public getWithoutMask() {
        return removeMasks(this.value);
    }

    public toString() {
        return this.getWithMask();
    }
}